export function highlightElement(element: Element, duration = 1800) {
  let originalStyle = element.getAttribute("style") || "";

  if (originalStyle.length > 0 && !originalStyle.endsWith(";"))
    originalStyle += ";";

  element.setAttribute(
    "style",
    `${originalStyle} box-shadow: 0 0 2px 2px #da6f38;`
  );
  element.classList.add("animate__animated", "animate__flash");
  setTimeout(() => {
    if (originalStyle.length > 0) element.setAttribute("style", originalStyle);
    else element.removeAttribute("style");

    element.classList.remove("animate__animated", "animate__flash");
  }, duration);
}

export function highlightElementQuerySelector(id: string, duration = 1800) {
  const element = document.querySelector(id);

  if (!element) return;
  highlightElement(element, duration);
}
